import { createAction } from "@reduxjs/toolkit";
import {
    GET_USER_CLASS_TYPE,
    USER_CLASS_TYPE_RECEIVED,
    GET_DISPLAY_NAME_MAPPING,
    DISPLAY_NAME_MAPPING_RECEIVED,
    GetAllUserClassTypeAction,
    AllUserClassTypeReceivedAction,
    GetDisplaynameMappingAction,
    DisplayNameMappingReceivedAction
} from "./types";

export const getAllUserClassType =
    createAction<GetAllUserClassTypeAction["payload"]>(GET_USER_CLASS_TYPE);

export const allUserClassTypeReceived =
    createAction<AllUserClassTypeReceivedAction["payload"]>(USER_CLASS_TYPE_RECEIVED);

export const getDisplayNameMapping =
    createAction<GetDisplaynameMappingAction["payload"]>(GET_DISPLAY_NAME_MAPPING);

export const displayNameMappingReceived = createAction<DisplayNameMappingReceivedAction["payload"]>(
    DISPLAY_NAME_MAPPING_RECEIVED
);
